import { SlotStatus } from "../enums";

/** Slot can be booked (Available or WaitlistAvailable) */
export const isBookableStatus = (status: SlotStatus | number): boolean =>
  status === SlotStatus.Available || status === SlotStatus.WaitlistAvailable;

/** Slot is on the waitlist */
export const isWaitlistStatus = (status: SlotStatus | number): boolean =>
  status === SlotStatus.WaitlistAvailable;

/** Slot is blocked / full */
export const isBlockedStatus = (status: SlotStatus | number): boolean =>
  status === SlotStatus.Blocked;
